import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { DollarSign, ShoppingCart, Users, Mail, TrendingUp, BookOpen, LogOut } from "lucide-react";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setStats(r.data)); }, []);
  if (!stats) return <div className="text-navy/60">Loading…</div>;

  const cards = [
    { i: DollarSign, label: "Revenue", value: `$${stats.total_revenue.toFixed(2)}`, tid: "stat-revenue" },
    { i: ShoppingCart, label: "Orders", value: stats.total_orders, tid: "stat-orders" },
    { i: TrendingUp, label: "Conversion", value: `${stats.conversion_pct}%`, tid: "stat-conversion" },
    { i: Mail, label: "Subscribers", value: stats.subscribers, tid: "stat-subscribers" },
    { i: Users, label: "Affiliates", value: stats.affiliates, tid: "stat-affiliates" },
    { i: BookOpen, label: "Ebooks", value: stats.ebooks, tid: "stat-ebooks" },
    { i: LogOut, label: "Silent Exits (7d)", value: stats.exit_intent_silent_7d ?? 0, tid: "stat-exit-intent-silent" },
  ];

  return (
    <div data-testid="admin-dashboard">
      <div className="eyebrow mb-2">Overview</div>
      <h1 className="aperture-h1 text-4xl mb-10">Dashboard.</h1>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-5">
        {cards.map((c) => (
          <div key={c.label} className="bg-white p-6 rounded-sm border" style={{ borderColor: "rgba(10,37,64,0.10)" }} data-testid={c.tid}>
            <div className="flex items-center justify-between">
              <div className="eyebrow">{c.label}</div>
              <c.i className="w-4 h-4 text-gold" strokeWidth={1.5} />
            </div>
            <div className="font-serif text-3xl text-navy mt-3">{c.value}</div>
          </div>
        ))}
      </div>
      <div className="mt-12 bg-white p-6 rounded-sm border" style={{ borderColor: "rgba(10,37,64,0.10)" }}>
        <div className="eyebrow mb-4">Top Sellers</div>
        {stats.top_sellers.length === 0 ? (
          <div className="text-sm text-navy/50">No sales yet.</div>
        ) : (
          <ul className="space-y-2">
            {stats.top_sellers.map((t, i) => (
              <li key={i} className="flex justify-between text-sm">
                <span className="text-navy">{t.title}</span>
                <span className="text-gold">{t.sold} sold</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
